import React from 'react'
import classNames from "classnames";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import mapStyle from "assets/jss/prehnit/components/mapStyle.jsx";

import { withNamespaces } from "react-i18next";

class ShowCoords extends React.Component {

  chooseCoordsX() {
    return this.props.mouseCoords ? this.props.mouseCoords[0] : this.props.centerCoords[0];
  }

  chooseCoordsY() {
    return this.props.mouseCoords ? this.props.mouseCoords[1] : this.props.centerCoords[1];
  }

  render() {
    const { t, classes } = this.props;
    return (
      <div id="show-coords" className={classNames(classes.dimTool, classes.showCoords)} >
        <span className={classes.noSelect}>{t("map:position")}: </span>
        {  Math.round(this.chooseCoordsX()) }, { Math.round(this.chooseCoordsY()) }
      </div>
    );
  }
}

export default withNamespaces()(withStyles(mapStyle)(ShowCoords));